<template>
  <client-only>
    <v-float-button-group class="w-128px px-1 py-1.5 bg-white">
      <div class="text-center text-[#3D3D3D] text-xs border-b border-[#E5E7EB] pb-3  mx-1 my-2">
        <el-image fit="cover" class="w-96px h-96px" v-if="url" :src="url"></el-image>
        <div>微信小程序</div>
        <div>查看和分享产品</div>
      </div>
      <div class="flex flex-wrap">
        <VFloatButton
          isFirst
          v-show="isLoggedIn && isDistributor"
          tag="nuxt-link"
          icon="ficon ficon-dianshangjiashangcheng-xianxing"
          title="商家中心"
          to="/resource"
          class="w-1/2"
          color="text-[#8C8C8C]"
          background="bg-white"
          icon_color="text-[#595959]"
          hover="hover:text-[#005EDC]"
          icon_hover="hover:text-[#005EDC]"
          active="active:text-[#005EDC]"
          icon_font_size="text-[24px]"
          margin_top="mt-1.5"
        />
        <VFloatButton
          v-show="isLoggedIn && isDistributor"
          tag="nuxt-link"
          icon="ficon ficon-dingdan"
          title="订单管理"
          to="/resource/order/platform"
          class="w-1/2"
          color="text-[#8C8C8C]"
          background="bg-white"
          icon_color="text-[#595959]"
          hover="hover:text-[#005EDC]"
          icon_hover="hover:text-[#005EDC]"
          active="active:text-[#005EDC]"
        />
        <VFloatButton
          :isFirst="!(isLoggedIn && isDistributor)"
          icon="ficon ficon-jiarudianpu"
          title="加入店铺"
          v-if="!isInShop && isOpenShop"
          @click="$emit('join')"
          class="w-1/2"
          color="text-[#8C8C8C]"
          background="bg-white"
          icon_color="text-[#595959]"
          hover="hover:text-[#005EDC]"
          icon_hover="hover:text-[#005EDC]"
          active="active:text-[#005EDC]"
          icon_font_size="text-[22px]"
          margin_top="mt-1.5"
        />
        <VFloatButton icon="ficon ficon-fenxiang_2" title="分享" @click="$emit('share')" class="w-1/2" color="text-[#8C8C8C]"
          background="bg-white"
          icon_color="text-[#595959]"
          hover="hover:text-[#005EDC]"
          icon_hover="hover:text-[#005EDC]"
          active="active:text-[#005EDC]"
          icon_font_size="text-[20px]"
          margin_top="mt-2"
        />
        <VFloatButton
          icon="ficon ficon-lianxiwomen"
          title="联系我们"
          @click="onOpenContact"
          class="w-1/2"
          color="text-[#8C8C8C]"
          background="bg-white"
          icon_color="text-[#595959]"
          hover="hover:text-[#005EDC]"
          icon_hover="hover:text-[#005EDC]"
          active="active:text-[#005EDC]"
          icon_font_size="text-[26px]"
        />
        <VFloatButton
          :icon="`ficon ${
            isFavorite ? 'ficon-xingzhuangjiehe6 text-primary' : 'ficon-a-zu344'
          }`"
          :title="isFavorite ? '已收藏' : '加入收藏'"
          @click="$emit('favorite')"
          class="w-1/2"
          color="text-[#8C8C8C]"
          background="bg-white"
          icon_color="text-[#595959]"
          hover="hover:text-[#005EDC]"
          icon_hover="hover:text-[#005EDC]"
          active="active:text-[#005EDC]"
          icon_font_size="text-[22px]"
          margin_top="mt-2"
        />
        <VFloatButtonBackTop class="w-1/2" type="detail" icon="ficon ficon-fanhuidingbu" color="text-[#8C8C8C]" background="bg-white" />
      </div>
    </v-float-button-group>
  </client-only>
</template>

<script>
import { computed, defineComponent, watch, useContext } from "@nuxtjs/composition-api";
import {
  VFloatButton,
  VFloatButtonGroup,
  VFloatButtonBackTop,
} from "~/components/VFloatButton";

import { useContactStore } from "~/composables/useContactDialog";
import { trackEvent } from "~/utils/track-event";

export default defineComponent({
  name: "ProductDetailTools",
  components: {
    VFloatButtonGroup,
    VFloatButton,
    VFloatButtonBackTop,
  },
  props: {
    isInShop: Boolean,
    isOpenShop: Boolean,
    isFavorite: Boolean,
    url: String,
  },
  emits: ["share", "favorite"],
  setup() {
    const { store } = useContext();
    const isLoggedIn = computed(() => store.getters.loggedIn);
    const isDistributor = computed(() => store.getters.isDistributor);
    const { open: openContact } = useContactStore();
    const onOpenContact = () => {
      openContact(true);
      trackEvent("5");
    };
    return {
      isLoggedIn,
      isDistributor,
      onOpenContact,
    };
  },
});
</script>

<style lang="scss" scoped>

</style>
